import { useQuery } from '@tanstack/react-query';
import { fetchConsoleVersion } from '../../../api/apis';

const POLL_INTERVAL_MS = 60_000;

export interface ConsoleVersion {
  /** Project version from package.json — only changes on release. */
  readonly v: string;
  /**
   * Hashed entry-chunk path of the deployed build, e.g. `/assets/index-BYpxAgtn.js`.
   * Absent on the Docker path. Changes on every deployment that shipped new code.
   */
  readonly buildId?: string;
}

/**
 * Polls /api/console-version every 60 seconds to detect when a new version
 * has been deployed. Compare the result against the build this tab is running
 * (see useIsNewDeploymentAvailable) to determine whether a newer deployment is
 * available.
 *
 * Runs everywhere. The endpoint exists on both the Cloudflare Pages and Docker
 * paths, and the comparison degrades on its own when the response carries no
 * buildId, so there is nothing here for a feature flag to decide.
 */
export const useConsoleVersion = (options = {}) => {
  return useQuery<ConsoleVersion>(
    ['console', 'version'],
    () => fetchConsoleVersion().then((resp: any) => resp.data),
    {
      ...options,
      refetchInterval: POLL_INTERVAL_MS,
      refetchIntervalInBackground: false,
    }
  );
};
